import Button from '@redbubble/design-system/src/Button';
import * as constants from '@redbubble/design-system/src/constants';
import RulerIcon from '@redbubble/design-system/src/Icons/Ruler';
import { useIntl } from '@redbubble/next/intl';
import { ModalSize, useOpenModal } from '@redbubble/next/modals';
import { FC, useState } from 'react';
import { messages } from './messages';
import {
  SizeGuideModalContent,
  SizeGuideModalContentLoadingState,
} from './SizeGuideModalContent';
import { useSizeGuide } from './SizeGuideProvider';

export interface SizeGuideButtonProps {
  onClick?: () => void;
}

export const SizeGuideButton: FC<SizeGuideButtonProps> = ({ onClick }) => {
  const intl = useIntl();
  const openModal = useOpenModal();
  const { productTypeId, hasSizing, getSizeGuide } = useSizeGuide();
  const [loading, setLoading] = useState(false);

  if (!hasSizing) {
    return null;
  }

  const handleClick = async () => {
    onClick?.();
    setLoading(true);
    const { sizeGuideData, initialGender, initialMeasurementUnit } =
      await getSizeGuide();
    setLoading(false);

    openModal({
      accessibleTitle: intl.formatMessage(messages.modalAccessibleTitle),
      content: sizeGuideData ? (
        <SizeGuideModalContent
          sizeGuideData={sizeGuideData}
          initialGender={initialGender}
          initialMeasurementUnit={initialMeasurementUnit}
          productTypeId={productTypeId}
        />
      ) : (
        <SizeGuideModalContentLoadingState />
      ),
      size: ModalSize.Large,
    });
  };

  return (
    <Button
      intent={constants.PRIMARY}
      size={constants.SMALL}
      iconBefore={<RulerIcon />}
      onClick={handleClick}
      loading={loading}
    >
      {intl.formatMessage(messages.openButtonText)}
    </Button>
  );
};
